import { pcfRoutes } from '@app/pcf/pcf-routes';
import { IngredientMiniResult, ProductMiniResult } from '@shared/api/types';
import Text from '@shared/components/content/text';
import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import FoodEmissionsBox from './food-emissions-box';
import ProductEmissionsBox from './product-emissions-box';

type ProductsInterface = { numShown: number } & (
  | { itemsType: 'Products'; items: readonly ProductMiniResult[] | null }
  | { itemsType: 'Foods'; items: readonly IngredientMiniResult[] | null }
);

const EMPTY_MESSAGES: Record<ProductsInterface['itemsType'], string> = {
  Products: 'No products to show yet.',
  Foods: 'No ingredients to show yet.',
};

const ProductsBox: React.FC<ProductsInterface> = (props) => {
  const { itemsType, numShown } = props;

  if (!props.items?.length) {
    return <Text variant="subtle">{EMPTY_MESSAGES[itemsType]}</Text>;
  }

  if (props.itemsType === 'Products') {
    return (
      <>
        {(props.items ?? []).slice(0, numShown).map((item) => (
          <div className="mb-2.5" key={item.uuid}>
            <Link
              to={generatePath(pcfRoutes.PRODUCT_DETAIL, {
                product_id: item.uuid,
              })}
            >
              <ProductEmissionsBox
                name={item.name}
                totalEmissionsPerKg={item.totalEmissionsPerKg}
                emissionsCategory={item.emissionsCategory}
                uuid={item.uuid}
                status={item.status}
              />
            </Link>
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {(props.items ?? []).slice(0, numShown).map((item) => (
        <div className="mb-2.5" key={item.uuid}>
          <FoodEmissionsBox
            name={item.longDesc}
            totalEmissionsPerKg={item.totalEmissionsPerKg}
            emissionsCategory={item.emissionsCategory}
            uuid={item.uuid}
            countryOfOrigin={item.countryOfOrigin}
          />
        </div>
      ))}
    </>
  );
};

export default ProductsBox;
